import type { Section } from '../types/report'
import { BlockRenderer } from './BlockRenderer'
import styles from './blocks.module.css'

// Render one section's blocks in order.
export function SectionView({ section }: { section: Section }) {
  return (
    <div className={styles.section}>
      {section.blocks.map((block, i) => (
        <BlockRenderer key={i} block={block} />
      ))}
    </div>
  )
}
